// extracted by mini-css-extract-plugin
export default {"table":"styles_table__CVpUc","table_header":"styles_table_header__B1KCu","icon":"styles_icon__qdNVL"};